module.exports = __webpack_public_path__ + "media/star-wars.7d1e3bb5.ogg";